import { ReactElement } from 'react';

import { Slice } from '@utmb/types/slice-handler';
import { SliceQuickLinksCollectionView } from '@utmb/types/index';
import { Link } from '@utmb/design-system/link/link';
import styles from './QuickLinksCollection.module.scss';
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
import { getColorStyle, getColorAndBgColorButton } from '@utmb/utils/colors';
import { ColorTypesEnum } from '@utmb/types/colors';
import { useGlobal } from '@utmb/contexts/GlobalContext';

export const QuickLinksCollection = (props: Slice<SliceQuickLinksCollectionView>): ReactElement | null => {
    const { id, links, color } = props;

    const rootCSS = [styles.root].filter(Boolean).join(' ');

    const {
        global: {
            event: { primaryColorIsDark, secondaryColorIsDark },
        },
    } = useGlobal();

    if (!links || !links.length) return null;

    const [textColor] = getColorAndBgColorButton(primaryColorIsDark, secondaryColorIsDark, color as unknown as ColorTypesEnum);

    return (
        <div id={id} className={rootCSS}>
            <div className={styles.container}>
                {links.map((data, i) => (
                    <Link key={i} className={styles.quickLink} href={data.link.slug}>
                        <div className={styles.background} style={{ background: getColorStyle(color) }} />
                        <div className={styles.content}>
                            {data.icon ? <Icon color={getColorStyle(textColor)} variant={data.icon} /> : null}
                            <div className={styles.wrapLabel}>
                                <Font.FuturaBook className={styles.label} color={getColorStyle(textColor)} desktop="18" mobile="18">
                                    {data.link.label}
                                </Font.FuturaBook>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};
